import React from 'react';
import Row from '../../../styleComponents/Row/Row';
import Col5 from '../../../styleComponents/Col5/Col5';
import Col7 from '../../../styleComponents/Col7/Col7';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import PanoramaOutlinedIcon from '@mui/icons-material/PanoramaOutlined';
import './Media.css'
import { Typography } from '@mui/material';

const Media = () => {
    return (
        <Box sx={{ py: 3 }}>
            <Row spacing={3} align={"top"}>
                <Col5>
                    <Box sx={{ textAlign: 'center' }}>
                        <form className="mediaForm">
                            <label htmlFor="image" className="imageLabel">
                                <PanoramaOutlinedIcon sx={{ fontSize: '70px' }} />
                                <Typography variant="inherit">Drag & Drop, Click Your Banner Image Hear</Typography>

                                <br />
                                <Button variant="contained" sx={{
                                    borderRadius: 0, border: '1px solid #ccc', bgcolor: '#fff', boxShadow: 'none', color: '#222', textTransform: 'capitalize', width: '250px', textAlign: 'center', ':hover': {
                                        bgcolor: '#fff', boxShadow: 'none'
                                    }
                                }}>
                                    Choose an image to upload
                                </Button>
                            </label>
                            <input type="file" name="image" id="image" />

                            <Button variant="contained" color="info" sx={{ borderRadius: 0 }}>
                                Upload Image
                            </Button>
                        </form>
                    </Box>
                </Col5>
                <Col7>
                    hi</Col7>
            </Row>
        </Box>
    );
};

export default Media;